import React from 'react'

export default function Header() {
  return (
    <header className="bg-white border-b border-gray-200">
      <div className="max-w-3xl mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <img src="/logo.svg" alt="Koru Kids" className="h-8 w-auto" />
          <div className="text-right">
            <h1 className="text-lg font-semibold text-gray-900">
              Nanny Briefing Pack
            </h1>
          </div>
        </div>
      </div>
    </header>
  )
}
